var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"component":_vm.$options.name}},[_c('v-progress-circular',{attrs:{"color":_vm.colour,"rotate":_vm.rotate,"size":_vm.size,"value":_vm.displayValue,"width":_vm.width}},[_c('span',{staticClass:"text-body-1 font-weight-medium"},[_vm._v(" "+_vm._s(_vm._f("numFormat")(_vm.bufferValue))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }